module.exports = __webpack_public_path__ + "static/img/周晓勇.8ee3dce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/周晓勇.jpg
// module id = Gxgu
// module chunks = 138